<template>
  <div>
    <div id="sidebarMenu" class="sidebar sidebar-fixed wd-350 t-0">
      <div class="sidebar-body pd-0">
        <div class="pd-x-10 pd-y-5">
          <h3 class="docs-logo">
            <router-link to="/"> Гарын<span>авлага</span> </router-link>
          </h3>
        </div>
        <div class="pd-5">
          <input placeholder="Хайх" v-model="filterText" class="form-control" />
        </div>

        <vue-custom-scrollbar style="height: calc(100vh - 95px);">
          <Tree
            ref="folterTree"
            node-key="id"
            node-key1="label"
            :data="folders"
            :props="defaultProps"
            @node-click="categoryChange"
            auto-expand-parent
            accordion
            :expand-on-click-node="true"
            highlight-current
            :current-node-key="$route.params.cid"
            :default-expanded-keys="expandKeys"
            :filter-node-method="filterNode"
            :key="treeKey"
            class="manual-tree"
          >
          </Tree>
        </vue-custom-scrollbar>
      </div>
      <!-- sidebar-body -->
    </div>
    <div class="content mg-l-350">
      <div class="container tx-color-03" style="max-width: 780px !important">
        <div v-if="$route.params.cid == 0">
          <h1 class="df-title">Гарын авлага</h1>
          <div class="row tx-14">
            <div
              class="col-sm-6"
              v-for="(f, i) in foldersFlat.filter(x => x.parentId == 0)"
              :key="i"
            >
              <div
                class="bg-white bd pd-20 pd-lg-30 ht-sm-300 d-flex flex-column justify-content-end"
              >
                <div class="mg-b-25">
                  <feather
                    :type="f.code"
                    :size="32"
                    class="wd-40-f ht-40-f"
                  ></feather>
                </div>
                <h5 class="tx-inverse mg-b-20">{{ f.title }}</h5>
                <p class="mg-b-20">{{ f.desc }}</p>
                <router-link
                  :to="{ name: 'landingHelp', params: { id: 0, cid: f.id } }"
                  class="tx-medium"
                  >{{ f.title }} үзэх <feather type="chevron-right"></feather
                ></router-link>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="
            foldersFlat.filter(x => x.parentId == $route.params.cid).length != 0
          "
        >
          <ul
            v-if="
              foldersFlat.filter(x => x.id == $route.params.cid)[0].field1 ==
                'list'
            "
            class="list-group"
          >
            <li
              class="list-group-item"
              v-for="(f, i) in foldersFlat.filter(
                x => x.parentId == $route.params.cid
              )"
              :key="i"
            >
              <feather type="help-circle" class="mg-r-10"></feather>
              <router-link
                :to="{ name: 'landingHelp', params: { id: 0, cid: f.id } }"
              >
                {{ f.title }}
              </router-link>
            </li>
          </ul>
          <div v-else class="row">
            <div
              class="col-sm-6"
              v-for="(f, i) in foldersFlat.filter(
                x => x.parentId == $route.params.cid
              )"
              :key="i"
            >
              <div class="bd pd-20">
                <h5>
                  <router-link
                    :to="{ name: 'landingHelp', params: { id: 0, cid: f.id } }"
                    class="link-01"
                    >{{ f.title }} <sup>({{ foldersFlat.filter(x => x.parentId == f.id).length }})</sup></router-link
                  >
                </h5>
                <ul class="list-unstyled lh-7 mg-b-0" style="overflow-y: scroll; max-height: 20vh;">
                  <li
                    v-for="(fs, i) in foldersFlat
                      .filter(x => x.parentId == f.id)"
                    :key="i"
                  >
                    <router-link
                      :to="{
                        name: 'landingHelp',
                        params: { id: 0, cid: fs.id }
                      }"
                    >
                      {{ fs.title }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-for="(t, i) in tasks" :key="i">
            <h4 class="tx-semibold mg-b-15">{{ t.task }}</h4>
            <div class="divider-text">Оршил</div>
            <div v-html="t.taskDescEn"></div>
            <div class="divider-text">Үндсэн мэдээлэл</div>
            <div v-html="t.taskDesc"></div>

            <template v-if="t.relatedTasks.length > 0">
              <div class="divider-text">Холбоотой мэдээлэл</div>
              <ul class="list-unstyled lh-7 mg-b-0">
                <li v-for="(t, i) in t.relatedTasks" :key="i">
                  <router-link
                    :to="{
                      name: 'landingHelp',
                      params: { id: t.id, cid: t.locTypeId }
                    }"
                  >
                    {{ t.task }}
                  </router-link>
                </li>
              </ul>
            </template>
            <!-- <hr class="mg-y-40"> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/api/all";
import { mapActions } from "vuex";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { Tree } from "element-ui";
var _ = require("lodash");
var LTT = require("list-to-tree");

export default {
  components: {
    Tree,
    vueCustomScrollbar
  },
  data() {
    return {
      filterText: "",
      categories: [],
      tasks: [],
      folders: [],
      defaultProps: {
        children: "children",
        label: "title",
        iid: "id"
      },
      foldersFlat: [],
      curId: null,
      expandKeys: [],
      treeKey: 0
    };
  },
  mounted() {
    require("@/assets/scss/pages/landing.scss");
    this.init();
    if (this.$route.params.cid > 0) {
      this.loadTask({ id: this.$route.params.cid });
    }
  },
  methods: {
    ...mapActions(["handleLoading"]),
    init() {
      request({
        api: { method: "GET", url: "Type/GetTreeData" },
        params: { parentId: 0, key: "userManualMenu" },
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          this.foldersFlat = _.orderBy(res.data.types, "ord", "asc");
          var ltt = new LTT(_.orderBy(res.data.types, "ord", "asc"), {
            key_id: "id",
            key_parent: "parentId",
            key_child: "children"
          });
          this.folders = _.orderBy(ltt.GetTree(), "ord", "asc");
          this.$nextTick(() => {
            this.setExpand();
          });
        }
      });
    },
    setExpand() {
      let me = this.foldersFlat.filter(x => x.id == this.$route.params.cid);
      if (me.length > 0) {
        let parent = this.foldersFlat.filter(x => x.id == me[0].parentId);
        this.expandKeys = [];
        this.$nextTick(() => {
          if (parent.length > 0) this.expandKeys = [parent[0].id, me[0].id];
          else this.expandKeys = [me[0].id];
        });
      }
    },
    getMyParentKeys() {},
    categoryChange(e) {
      this.curId = e.id;
      this.$router.push({ name: "landingHelp", params: { id: 0, cid: e.id } });
    },
    loadTask(e) {
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "POST", url: "task/getDataHelp" },
        data: {
          ot: 492,
          skip: 0,
          size: 500,
          model: {
            locTypeId: e.id,
            isPublic: true
          }
        },
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          this.tasks = _.orderBy(res.data.tasks, "ord", "asc");
          //console.log(this.tasks);
        }
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    }
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.cid == 0) {
        this.treeKey++;
      } else if (newRoute.params.id > 0) {
        this.treeKey++;
      }
      if (newRoute.params.cid != oldRoute.params.cid) {
        this.$nextTick(() => {
          this.setExpand();
          this.loadTask({ id: newRoute.params.cid });
        });
      }
    },
    filterText(val) {
      this.$refs.folterTree.filter(val);
    }
  }
};
</script>
